import { Injectable, NgZone } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { AppService } from '../../app-service/logic/app.service';
import { CredentialsService } from '../../credentials/logic/credentials.service';
import { NavController } from '@ionic/angular';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { RemoteActionBuilderService } from '../../remote-action-builder/remote-action-builder.service';
import { LocationService } from '../../location/location.service';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';
import { TourTravelRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/tour-travel-remote-action-builder/tour-travel-remoteaction-builder';
import { TourTravelRemoteActionType } from 'src/app/_model/remote-action/remote-action-builder/tour-travel-remote-action-builder/tour-travel-remote-action-type';
import { TourService } from '../../tour/logic/tour.service';
import { GPSTrackService } from '../../gps-track/gps-track.service';

@Injectable({
  providedIn: 'root',
})
export class StartOfTourActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'sot';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private appService: AppService,
    private credentialsService: CredentialsService,
    private navigationController: NavController,
    private clientStateService: ClientStateService,
    private remoteActionBuilderService: RemoteActionBuilderService,
    private locationService: LocationService,
    private appParameterService: AppParameterService,
    private tourService: TourService,
    private gpsTrackingService: GPSTrackService,
    private zone: NgZone
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    const state = this.clientStateService.theState.getValue();
    const tour = this.tourService.getTourById(state?.tourId);
    if (state?.tourId == undefined) {
      return;
    }

    this.remoteActionBuilderService.newBuild(
      new TourTravelRemoteActionBuilder(
        TourTravelRemoteActionType.START_OF_TOUR,
        tour,
        undefined,
        undefined,
        this.clientStateService,
        this.appService,
        this.credentialsService,
        this.locationService,
        this.tourService,
        this.gpsTrackingService,
        this.appParameterService,
        this.logger
      )
    );
    this.navigationController.navigateForward('/feature/remote-action');
  }

  // Private Functions
}
